class AMBoutiqueSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-am-boutique-track]');
    this.bar = this.querySelector('[data-am-boutique-progress-bar]');
    this.prevBtn = this.querySelector('[data-am-boutique-prev]');
    this.nextBtn = this.querySelector('[data-am-boutique-next]');
    if (!this.track) return;

    this.update = this.update.bind(this);
    this.scrollByCard = this.scrollByCard.bind(this);

    this.track.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update, { passive: true });

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
    }

    this.update();
  }

  scrollByCard(direction) {
    const firstCard = this.track.querySelector('.am-boutique-cards__card');
    if (!firstCard) return;
    const styles = getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;
    const step = firstCard.offsetWidth + gap;
    this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const max = scrollWidth - clientWidth;

    if (this.bar) {
      if (max <= 0) {
        this.bar.style.width = '100%';
        this.bar.style.left = '0%';
      } else {
        const visibleRatio = clientWidth / scrollWidth;
        const scrollProgress = scrollLeft / max;
        this.bar.style.width = `${visibleRatio * 100}%`;
        this.bar.style.left = `${scrollProgress * (1 - visibleRatio) * 100}%`;
      }
    }

    /* Tolerance must cover the track's horizontal padding because scroll-snap
       lands the first/last card at scrollLeft = paddingLeft (not 0) and
       scrollLeft = max - paddingRight (not max). Without this, the prev/next
       buttons flicker disabled→active at the boundaries. */
    const styles = getComputedStyle(this.track);
    const padLeft = parseFloat(styles.paddingLeft) || 0;
    const padRight = parseFloat(styles.paddingRight) || 0;

    if (this.prevBtn) {
      this.prevBtn.disabled = scrollLeft <= padLeft + 1;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = scrollLeft >= max - padRight - 1;
    }
  }
}

if (!customElements.get('am-boutique-slider')) {
  customElements.define('am-boutique-slider', AMBoutiqueSlider);
}
